import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@tsgecart/ui';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold',
  {
    variants: {
      variant: {
        brand: 'bg-brand text-brand-foreground',
        dark: 'bg-slate-900/90 text-white backdrop-blur-sm',
        discount: 'bg-rose-500 text-white',
        outline: 'border border-gray-200 bg-white text-slate-700',
      },
    },
    defaultVariants: {
      variant: 'brand',
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  ),
);
Badge.displayName = 'Badge';
